import { getCookie } from "./utils/getCookie";
import { setCookie } from "./utils/setCookie";

$(document).ready(function () {
  var $wrapper = $('[data-sign-up-modal]');
  var $modalbackdrop = $('#modalbackdrop');
  var $closeBtn = $('[data-sign-up-modal-close]');
  var $openBtn = $('[data-sign-up-modal-open]');
  var $submitModal = $('[data-sigin-up-modal-submit]')
  var $form = $wrapper.find('form');

  var submit = function (e, type) {

    var identityFieldsToTrack = [
      {
        selector: "[name=\"contact[First Name]\"]",
        klaviyoFieldName: "$first_name"
      },
      {
        selector: "[name=\"contact[Last Name]\"]",
        klaviyoFieldName: "$last_name"
      },
      {
        selector: "[name=\"contact[email]\"]",
        klaviyoFieldName: "$email"
      },
      {
        selector: "[name=\"contact[State]\"]",
        klaviyoFieldName: "$region"
      },
      {
        selector: "[name=\"contact[Enquiry Type]\"]:checked",
        klaviyoFieldName: "enquiry_type"
      }
    ];

    var identityKeyValue = {};
    identityFieldsToTrack.forEach(function (identityField) {
      var $element = $form.find(identityField.selector);
      var elementValue = $element.val();
      identityKeyValue[identityField.klaviyoFieldName] = elementValue;
    });

    if (identityKeyValue.$first_name.length > 0 && identityKeyValue.$last_name.length > 0 && identityKeyValue.$region.length > 0) {

      // Define Klaviyo Object
      var klaviyo = window.klaviyo || [];
      // Identify Profile
      klaviyo.push(["identify", identityKeyValue]);
      // TODO: is this still in use? consider push to metrics if yes

      window.dataLayer.push({
        event: 'Newsletter customise information'
      });

    }

    localStorage.setItem("sign-up-modal-submitted", true);

  }

  if ($wrapper.length) {

    $closeBtn.on('click', function () {
      $wrapper.css('display', 'none');
      $wrapper.css('opacity', 0);
      $modalbackdrop.css('display', 'none');
      setCookie("sign-up-modal-close", 'true', 365);
    });

    $openBtn.on('click', function () {

    });

    if (getCookie("sign-up-modal-close") === 'true') {

    }
    else {
      setTimeout(function () {
        $wrapper.css('display', 'block');
        $wrapper.css('opacity', 1);
        $modalbackdrop.css('display', 'block');
      }, 5000);

      setCookie("sign-up-modal-close", 'true', 365);
    };

    $submitModal.on('click', function (e) {
      submit(e);
    });


  }

});